// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Step from "./step.js"
import TeamSurvey from "./team-survey.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "is_finished": {
      "column": null,
      "name": "is_finished",
      "selected_by_default": null,
      "translated": null
    },
    "started_at": {
      "column": {
        "default": null,
        "name": "started_at",
        "null": true,
        "type": "datetime"
      },
      "name": "started_at",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "unfinished",
        "name": "state",
        "null": true,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "submitted_by_timer": {
      "column": {
        "default": null,
        "name": "submitted_by_timer",
        "null": true,
        "type": "boolean"
      },
      "name": "submitted_by_timer",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_id": {
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": true,
        "type": "uuid"
      },
      "name": "team_survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "total_score": {
      "column": {
        "default": 0,
        "name": "total_score",
        "null": false,
        "type": "integer"
      },
      "name": "total_score",
      "selected_by_default": null,
      "translated": null
    },
    "next_user_step": {
      "column": null,
      "name": "next_user_step",
      "selected_by_default": false,
      "translated": null
    },
    "previous_user_step": {
      "column": null,
      "name": "previous_user_step",
      "selected_by_default": false,
      "translated": null
    },
    "time": {
      "column": null,
      "name": "time",
      "selected_by_default": false,
      "translated": null
    },
    "timer_seconds_left": {
      "column": null,
      "name": "timer_seconds_left",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "UserStep",
  "collectionKey": "user_steps",
  "collectionName": "user_steps",
  "i18nKey": "user_step",
  "camelizedLower": "userStep",
  "name": "UserStep",
  "nameDasherized": "user-step",
  "pluralName": "user_steps",
  "ransackable_associations": [
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "user_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": "user_elements"
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "team_survey"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "option_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "Option",
      "through": "answers"
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "team_survey"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserElement",
      "collectionName": "user_elements",
      "foreignKey": "user_step_id",
      "name": "user_elements",
      "macro": "has_many",
      "resource_name": "UserElement",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "finished_at",
      "column": {
        "default": null,
        "name": "finished_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_step_id",
      "column": {
        "default": null,
        "name": "old_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_survey_id",
      "column": {
        "default": null,
        "name": "old_team_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "started_at",
      "column": {
        "default": null,
        "name": "started_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "unfinished",
        "name": "state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "step_id",
      "column": {
        "default": null,
        "name": "step_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "submitted_by_timer",
      "column": {
        "default": null,
        "name": "submitted_by_timer",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "team_survey_id",
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "total_score",
      "column": {
        "default": 0,
        "name": "total_score",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    }
  ],
  "paramKey": "user_step",
  "primaryKey": "id"
}

/** Frontend model for UserStep. */
export default class UserStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isFinished() {
    return this.readAttributeUnderscore("is_finished")
  }

  /** @returns {boolean} */
  hasIsFinished() {
    const value = this.isFinished()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  startedAt() {
    return this.readAttributeUnderscore("started_at")
  }

  /** @returns {boolean} */
  hasStartedAt() {
    const value = this.startedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  submittedByTimer() {
    return this.readAttributeUnderscore("submitted_by_timer")
  }

  /** @returns {boolean} */
  hasSubmittedByTimer() {
    const value = this.submittedByTimer()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  teamSurveyId() {
    return this.readAttributeUnderscore("team_survey_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyId() {
    const value = this.teamSurveyId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  totalScore() {
    return this.readAttributeUnderscore("total_score")
  }

  /** @returns {boolean} */
  hasTotalScore() {
    const value = this.totalScore()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nextUserStep() {
    return this.readAttributeUnderscore("next_user_step")
  }

  /** @returns {boolean} */
  hasNextUserStep() {
    const value = this.nextUserStep()

    return this._isPresent(value)
  }

  /** @returns {any} */
  previousUserStep() {
    return this.readAttributeUnderscore("previous_user_step")
  }

  /** @returns {boolean} */
  hasPreviousUserStep() {
    const value = this.previousUserStep()

    return this._isPresent(value)
  }

  /** @returns {any} */
  time() {
    return this.readAttributeUnderscore("time")
  }

  /** @returns {boolean} */
  hasTime() {
    const value = this.time()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  timerSecondsLeft() {
    return this.readAttributeUnderscore("timer_seconds_left")
  }

  /** @returns {boolean} */
  hasTimerSecondsLeft() {
    const value = this.timerSecondsLeft()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  finish(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "finish",
        primaryKey: this.primaryKey(),
        collectionName: "user_steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  start(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "start",
        primaryKey: this.primaryKey(),
        collectionName: "user_steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  timerTimedOut(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "timer_timed_out",
        primaryKey: this.primaryKey(),
        collectionName: "user_steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateScore(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_score",
        primaryKey: this.primaryKey(),
        collectionName: "user_steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./step.js").default | null} */
  step() {
    return this._readBelongsToReflection({modelClass: Step, reflectionName: "step"})
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  loadStep() {
    if (!("stepId" in this)) throw new Error("Foreign key method wasn't defined: stepId")

    const id = this.stepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "step",
        model: this,
        modelClass: Step
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  ensureStepLoaded() {
    return this.ensureAssociationLoaded("step")
  }

  /** @returns {import("./team-survey.js").default | null} */
  teamSurvey() {
    return this._readBelongsToReflection({modelClass: TeamSurvey, reflectionName: "team_survey"})
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  loadTeamSurvey() {
    if (!("teamSurveyId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyId")

    const id = this.teamSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team_survey",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  ensureTeamSurveyLoaded() {
    return this.ensureAssociationLoaded("team_survey")
  }
}
